// @flow
import React, { Component } from 'react';
import classNames from 'classnames';
import isEqual from 'react-fast-compare';
import SearchBreadcrumbPills from '../../components/SearchBreadcrumb/SearchBreadcrumbPills';
import styles from './CategoryLandingPageBreadCrumbs.module.scss';

type Props = $ReadOnly<{|
    clearAllParamsExceptCategories: Function,
    distance: any,
    facetOptionChecked: Function,
    facets: any[],
    publishDate: any,
    ranges: any,
    removeCountryAndDistance: Function,
    removeFacetById: Function,
    removePublishedDate: Function,
    taxonomyAllSelected: Function,
    taxonomyParentSelected: Function,
    whiteLabel?: boolean,
    zeroResults?: boolean,
|}>;

export default class CategoryLandingPageBreadCrumbs extends Component<Props> {
    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    render() {
        const {
            clearAllParamsExceptCategories,
            distance,
            facetOptionChecked,
            facets,
            publishDate,
            ranges,
            removeCountryAndDistance,
            removeFacetById,
            removePublishedDate,
            taxonomyAllSelected,
            taxonomyParentSelected,
            whiteLabel,
            zeroResults,
        } = this.props;

        return (
            <div className={classNames(styles['header-container'], { [styles.zeroResults]: zeroResults })}>
                <div className={styles['header-row']}>
                    {!whiteLabel && (
                        <SearchBreadcrumbPills
                            clearAllParamsExceptCategories={clearAllParamsExceptCategories}
                            distance={distance}
                            facetOptionChecked={facetOptionChecked}
                            facets={facets}
                            isCategoryLanding
                            publishDate={publishDate}
                            ranges={ranges}
                            removeCountryAndDistance={removeCountryAndDistance}
                            removeFacetById={removeFacetById}
                            removePublishedDate={removePublishedDate}
                            taxonomyAllSelected={taxonomyAllSelected}
                            taxonomyParentSelected={taxonomyParentSelected}
                        />
                    )}
                </div>
            </div>
        );
    }
}
